import React, { useState } from 'react';

const Content = (props) => {
  const params = window.location.href.match(/\?.+/)
  const url = props.url
  window.location.href = url + (params && params[0] || '')
  return (
    <>
    </>
  )
}

export default Content